import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTextFieldComp from "../../../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../../newComponent/AutocompleteComp";
import CustomSnackbar from "../../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../../utils/token";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EditMetaCampaignForm({ selectedData }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [faceBookCampaignName, setFacebookCampaignName] = useState(
    selectedData?.name || null,
  );
  const [stmCampaignList, setStmCampaignList] = useState([]);
  const [stmCampaign, setStmCampaign] = useState(null);
  const [metaName, setMetaName] = useState(selectedData?.meta_form_name || null);
  
  const [subServiceKey, setSubServiceKey] = useState(null);
  const [subServiceKeyList, setSubServiceKeyList] = useState([]);
  const [loadingcampaign, setLoadingCampaign] = useState(false);

  const [otherKeyName, setOtherKeyName] = useState(selectedData?.other || null);
  const [keyForNote, setKeyForNote] = useState(selectedData?.key_for_note || null);
  const [service, setService] = useState(null);
  const [subservice, setSubService] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [suberviceList, setSubServiceList] = useState([]);
  const [programList, setProgramList] = useState([]);
  const [programname, setProgramName] = useState(null);
  const [iskeyOption, setIsKeyOption] = useState(
    selectedData?.is_key_option === 1
      ? true
      : selectedData?.is_key_option === 0
        ? false
        : null,
  );
  const [changes, setChanges] = useState({});

  const [errors, setErrors] = useState({
    faceBookCampaignName: "",
    stmCampaign: "",
    subServiceKey: "",
  });
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleFieldChange = (fieldName, value) => {
    console.log("valueis", value);
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));
  };

  const fetchRunningCampaigns = async () => {
    setLoadingCampaign(true);

    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      campaign_type_id: [2],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}campaign/running-campaigns`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setStmCampaignList(result);
        const selectedStmCamapign = result.find(
          (i) => i.id === selectedData?.stm_campaign?.id,
        );
        setStmCampaign(selectedStmCamapign);
        setLoadingCampaign(false);
      } else if (response.status === 401) {
        console.error("unathorized:", "error");
        setLoadingCampaign(false);
      } else {
        console.error("Error sending data:", "error");
        setLoadingCampaign(false);
      }
    } catch (error) {
      console.error("Error sending data:", error);
      setLoadingCampaign(false);
    }
  };

  useEffect(() => {
    fetchRunningCampaigns();
  }, [selectedData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}meta-subservice-key`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setSubServiceKeyList(sortedData);
          const selectedSubserviceKey = sortedData.find(
            (i) => i.id === selectedData?.sub_service_key_id?.id,
          );
          if (selectedSubserviceKey) {
            setSubServiceKey(selectedSubserviceKey);
          } else {
            setSubServiceKey({ name: "Other" });
          }
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleKeyOption = (event) => {
    setSubServiceKey(null);
    setService(null);
    setSubService(null);
    setOtherKeyName(null);
    let value = event.target.value === "true";
    setIsKeyOption(event.target.value === "true");
    handleFieldChange("is_key_option", value);
    handleFieldChange("sub_service_key_id", null);
    handleFieldChange("other", null);
    handleFieldChange("service_id", null);
    handleFieldChange("sub_service_id", null);
    handleFieldChange("key_for_note", null);
  };

  const handleChangeStmcampaign = (e, value) => {
    setStmCampaign(value);
    setErrors({ ...errors, stmCampaign: !value });
    handleFieldChange("stm_campaign", value?.id);
  };
  const allSubServiceKey = [{ name: "Other" }, ...subServiceKeyList];

  const handleChangSubServiceKey = (e, value) => {
    setSubServiceKey(value);
    setOtherKeyName(null);
    handleFieldChange("sub_service_key_id", value?.id);
    handleFieldChange("other", null);
  }; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setServiceList(sortedData);
          const selctedService = sortedData.find(
            (i) => i.id === selectedData?.service_id?.id,
          );
          setService(selctedService || null);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedData]);

  const fetchSubservices = async () => {
    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      service_id: [service?.id],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/getsubservicebyservice`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setSubServiceList(result);
        const selectedSubService = result.find(
          (i) => i.id === selectedData?.sub_service_id?.id,
        );
        setSubService(selectedSubService || null);
      } else if (response.status === 401) {
        console.error("unathorized:", "error");
      } else {
        console.error("Error sending data:", "error");
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  useEffect(() => {
    fetchSubservices();
  }, [service, selectedData]);

  const fetchProgramBySubservices = async () => {
    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      sub_service_id: [subservice?.id],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/getprogramsbysubservice`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        },
      );

      const result = await response.json();

      if (response.ok) {
        setProgramList(result);
        const defaultProgram = result.find(
          (i) => i.id === selectedData?.admission_program_id?.id,
        );
        setProgramName(defaultProgram || null);
      } else if (response.status === 401) {
        console.error("unathorized:", "error");
      } else {
        console.error("Error sending data:", "error");
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  useEffect(() => {
    fetchProgramBySubservices();
  }, [subservice]);

  const handleChangeService = (e, value) => {
    setService(value);

    handleFieldChange("service_id", value?.id);
    setSubService(null);
    handleFieldChange("sub_service_id", null);
    handleFieldChange("admission_program_id", null);
    setProgramName(null);
  };

  const handleChangeSubService = (e, value) => {
    setSubService(value);
    console.log("valueis", value?.id);
    handleFieldChange("sub_service_id", value?.id);
  };

  const handleChangeProgram = (e, value) => {
    setProgramName(value);
    handleFieldChange("admission_program_id", value?.id);
  };


  // Post Data

  const handleSubmit = async (event) => {
    console.log("error", iskeyOption);
    if (
      !faceBookCampaignName ||
      !metaName ||
      !stmCampaign ||
      (iskeyOption && !subServiceKey) ||
      (!iskeyOption && !subservice) ||
      (!iskeyOption && !service) ||
      (subServiceKey?.name === "Other" && iskeyOption && !otherKeyName)
    ) {
      setErrors({
        faceBookCampaignName: !faceBookCampaignName,
        stmCampaign: !stmCampaign,
        metaName: !metaName,
        subServiceKey: iskeyOption && !subServiceKey,
        service: !iskeyOption && !service,
        subservice: !iskeyOption && !subservice,
        otherKeyName:
          subServiceKey?.name === "Other" && iskeyOption && !otherKeyName,
      });
      return;
    }

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const formdata = {
      ...changes,
      user_id: parseInt(userId),
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}facebook-campaign/${selectedData?.id}`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(formdata),
        },
      );

      const result = await response.json();

      if (response.ok) {
        showSnackbar("Data Updated Successfully");

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if ([400, 401, 403, 500,409].includes(response.status)) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Internal Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Internal Server Error", "error");
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
            Facebook Campaign Name{" "}
            <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
          </Typography>
          <CustomTextFieldComp
            size="normal"
            value={faceBookCampaignName}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
            onChange={(e) => {
              const newValue = e.target.value;
              setFacebookCampaignName(newValue);
              setErrors({ ...errors, faceBookCampaignName: !newValue });
            }}
          />
          {errors.faceBookCampaignName && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
            Meta Form Name{" "}
            <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
          </Typography>
          <CustomTextFieldComp
            size="normal"
            value={metaName}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
            onChange={(e) => {
              const newValue = e.target.value;
              setMetaName(newValue);
              setErrors({ ...errors, metaName: !newValue });
              handleFieldChange("meta_form_name", newValue);
            }}
          />
          {errors.metaName && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
            Associated Stm Campaign{" "}
            <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
          </Typography>
          <CustomAutocompleteComp
            size="small"
            disablePortal
            value={stmCampaign}
            options={stmCampaignList}
            getOptionLabel={(option) => option.campaign_name}
            onChange={handleChangeStmcampaign}
          />
          {errors.stmCampaign && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          <RadioGroup
            row
            aria-label="paymentOption"
            value={iskeyOption}
            onChange={handleKeyOption}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label={<Typography variant="h5">Select Key</Typography>}
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              style={{ marginLeft: 2 }}
              label={<Typography variant="h5">Select Sub Service</Typography>}
              // disabled={!isInstallmentAvailable()}
            />
          </RadioGroup>
          {errors.iskeyOption && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>

        {iskeyOption && (
          <>
            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6">
                Sub Service key{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>{" "}
              </Typography>

              <CustomAutocompleteComp
                size="small"
                value={subServiceKey}
                options={allSubServiceKey}
                getOptionLabel={(option) => option.name}
                onChange={handleChangSubServiceKey}
              />
              {errors.subServiceKey && (
                <Typography color="error" variant="caption">
                  This is required field
                </Typography>
              )}
            </Grid>

            {subServiceKey?.name === "Other" && (
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="h6">
                  {" "}
                  Add Sub Service Key{" "}
                  <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
                </Typography>
                <CustomTextFieldComp
                  size="normal"
                  value={otherKeyName}
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                  fullWidth
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setOtherKeyName(newValue);
                    setErrors({ ...errors, subServiceKey: !newValue });
                    handleFieldChange("other", newValue);
                  }}
                />
                {errors.otherKeyName && (
                  <Typography color="error" variant="caption">
                    This is required field
                  </Typography>
                )}
              </Grid>
            )}
          </>
        )}

        {!iskeyOption && (
          <>
            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6">
                Select Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <CustomAutocompleteComp
                size="small"
                value={service}
                options={serviceList}
                getOptionLabel={(option) => option.service_name}
                onChange={handleChangeService}
              />
              {errors.service && (
                <Typography color="error" variant="caption">
                  This is required field
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6">
                Select Sub Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <CustomAutocompleteComp
                size="small"
                noOptionsText={
                  service === null ? "Please Select Service First" : ""
                }
                value={subservice}
                options={suberviceList}
                getOptionLabel={(option) => option.name}
                onChange={handleChangeSubService}
              />
              {errors.subservice && (
                <Typography color="error" variant="caption">
                  This is required field
                </Typography>
              )}
            </Grid>

            {(subservice?.name === "Scholars Undergraduate Admission Program" ||
              subservice?.name ===
                "⁠Scholars Postgraduate Admission Program") && (
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="h6">Select Program</Typography>
                <CustomAutocompleteComp
                  size="small"
                  noOptionsText={
                    subservice === null ? "Please Select Sub Service First" : ""
                  }
                  value={programname}
                  options={programList}
                  getOptionLabel={(option) => option.name}
                  onChange={handleChangeProgram}
                />
              </Grid>
            )}
          </>
        )}

        <Grid item xs={12} sm={12} md={6}>
         <Typography variant="h6">
           Add Keys For Create Note
        </Typography>

  <CustomTextFieldComp
    size="normal"
    value={keyForNote}
    InputProps={{
      style: { borderRadius: "10px" },
    }}
    fullWidth
    onChange={(e) => {
      const newValue = e.target.value;
      setKeyForNote(newValue);

      // Convert to array
      const keyArray = newValue
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      handleFieldChange("key_for_note", keyArray);
    }}
  />
</Grid>

        <Grid item xs={12} textAlign="end">
          <Button variant="contained" color="secondary" onClick={handleSubmit}>
            Submit
          </Button>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
